import { useState } from "react";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import { useDeleteFiatAccountMutation, useGetCicoFiatAccountsQuery } from "apis";
import { DeleteSVG } from "assets";
import { CircularLoader } from "components";

const GetAccounts = () => {
  const { data } = useGetCicoFiatAccountsQuery({});

  const [_deleteAccount, { isLoading }] = useDeleteFiatAccountMutation();
  const [fiatId, setFiatId] = useState("");

  const handleDelete = async (id: string) => {
    setFiatId(id);
    await _deleteAccount(id);
  };

  console.log(data);

  return (
    <Box>
      {data && Object.values(data).length === 0 && (
        <Center mt="24px">
          <Text>You have no Fiat Account</Text>
        </Center>
      )}

      {data?.BankAccount?.map(({ accountName, fiatAccountId, institutionName }) => {
        return (
          <Box
            padding="24px"
            key={fiatAccountId}
            width="100%"
            borderRadius="24px"
            bg="linear-gradient(to left, #9ace80, #0D4740)"
            color="#fff"
            mb="24px"
          >
            <Flex justifyContent="space-between">
              <Box>
                <Text fontWeight="600" textTransform="capitalize">
                  {accountName?.toLowerCase()}
                </Text>
                <Text textTransform="uppercase">{institutionName}</Text>
              </Box>

              <Center
                cursor="pointer"
                width="32px"
                height="32px"
                borderRadius="100%"
                bg="#fff"
                onClick={() => handleDelete(fiatAccountId)}
              >
                {isLoading && fiatId === fiatAccountId ? <CircularLoader /> : <DeleteSVG width="16px" height="16px" />}
              </Center>
            </Flex>
          </Box>
        );
      })}
    </Box>
  );
};

export default GetAccounts;
